const CardDragInsertionPoint = () => {
  return (
    <div className="card-drag-insertion-point" />
  );
};

export default CardDragInsertionPoint;
